<template>
    <div class="relative rounded-full flex border-2  "
        :class="{'bg-white border-gray-300':!checked,'bg-blue-500 border-blue-500':checked, 'cursor-pointer': !disabled, 'opacity-50': disabled, 'w-10 h-6': the_size=='base', 'w-7 h-4': the_size=='sm'}"
        @click="toggle()">
        <div class="absolute rounded-full border border-white transition duration-200 "
            :class="{'bg-gray-300 left-0':!checked,'bg-white right-0':checked, 'w-5 h-5': the_size=='base', 'w-3 h-3': the_size=='sm'}"><spinner v-if="loading" class="w-full h-full"></spinner></div>
    </div>
</template>

<script>
import Spinner from '@/Components/UI/Spinner'
export default {
    emits: ['update'],
    components: {
        Spinner,
    },
    props: {
        loading: {
            type: Boolean,
            default: false,
        },
        size: {
            type: String,
            default: 'base',
        },
        checked: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        }
    },
    created() {
        this.the_size = this.size
        if (this.size != 'base' && this.size != 'sm') {
            this.the_size = 'base'
        }
    },
    // watch: {
    //     checked: {
    //
    //     }
    // },
    data() {
        return {
            the_size: 'base'
        }
    },
    computed: {
        proxyChecked: {
            get() {
                return this.checked;
            },

            set(val) {
                //this.$emit("update", val);
            },
        },
    },
    methods: {
        toggle: function() {
            if (this.disabled) {
                return
            }
            //this.is_checked = !this.is_checked
            this.$emit("update", !this.checked);
        }
    },
}
</script>
<style scoped>

</style>
